import { render, staticRenderFns } from "./SurveysCreate.vue?vue&type=template&id=31e4c611&scoped=true"
import script from "./SurveysCreate.vue?vue&type=script&lang=js"
export * from "./SurveysCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e4c611",
  null
  
)

export default component.exports